import React from 'react';
import {ModelFormContext} from "./ModelFormHOC";
import {FormHook} from "../lib/formHook";

interface FormProps {
  form: FormHook;
}

const Form: React.FC<FormProps> = (props) => {
  const {children} = props;
  const {formDef, formState, setFieldValue} = props.form;

  const onChangeValue = (fieldName:string, value:any, touched:boolean=true) => {
    // console.log('onChangeValue', fieldName, value, touched);
    setFieldValue(fieldName, value, touched);
  }

  return (
    <ModelFormContext.Provider
      value={{
        formDefinition: formDef,
        onChangeValue: onChangeValue,
        formState: formState,
      }}
    >
      <div>
        {children}
      </div>
    </ModelFormContext.Provider>
  );
}

export default Form;
